import { SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/empty-state";

export interface FilteredEmptyStateProps {
  title?: string;
  description?: string;
  onReset?: () => void;
  resetLabel?: string;
  variant?: "default" | "compact";
  className?: string;
  unframed?: boolean;
}

export function FilteredEmptyState({
  title = "No matching results",
  description = "No items match your active filters or search query. Try clearing filters to see more.",
  onReset,
  resetLabel = "Reset filters",
  variant = "compact",
  className,
  unframed = false,
}: FilteredEmptyStateProps) {
  return (
    <EmptyState
      icon={SearchX}
      title={title}
      description={description}
      variant={variant}
      unframed={unframed}
      className={className}
      actions={
        onReset ? (
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={onReset}
            className="rounded-full"
          >
            {resetLabel}
          </Button>
        ) : undefined
      }
    />
  );
}
